<template>
  <v-container class="info-panel pa-0">
    <v-row dense>
      <v-col class="align-center">
        <v-card flat class="pa-4">
          <v-row dense class="mb-4">
            <v-col cols="12" class="d-flex align-center">
              <v-icon color="grey lighten-1" size="40">mdi-information-slab-box</v-icon>
              <v-subheader class="title pl-1">Rechercher un agent, une agence</v-subheader>
            </v-col>
            <v-col cols="12">
              <v-divider />
            </v-col>
          </v-row>

          <v-row class="pl-4">
            <v-col cols="3" class="d-flex flex-column align-center">
              <div class="d-flex align-center mb-1" >
                <v-icon color="grey lighten-1" size="28">mdi-magnify</v-icon>
                <p class="font-weight-bold grey--text text--darken-1">Recherche basique</p>
              </div>
              <p class="caption">
                Retrouvez le(s) participant(s) à votre session de workshop en recherchant
                <span class="font-weight-medium">un agent ou une agence</span>.
                Le recherche par défaut cible les deux.
              </p>
            </v-col>

            <v-col cols="3" class="d-flex flex-column align-center">
              <div class="d-flex align-center mb-1" >
                <v-icon color="grey lighten-1" class="mr-1" size="28">mdi-home-outline</v-icon>
                <p class="font-weight-bold grey--text text--darken-1">Recherche par agence</p>
              </div>
              <p class="caption">
                Sélectionnez cette icône pour cibler uniquement les agences.
                Vous pouvez rechercher une agence par
                <span class="font-weight-medium">nom, email, adresse ou code postal</span>.
              </p>
            </v-col>

            <v-col cols="3" class="d-flex flex-column align-center">
              <div class="d-flex align-center mb-1" >
                <v-icon color="grey lighten-1" class="mr-1" size="28">mdi-face-agent</v-icon>
                <p class="font-weight-bold grey--text text--darken-1">Recherche par agent</p>
              </div>
              <p class="caption">
                Sélectionner cette icône pour cibler uniquement les agents.
                Vous pouvez rechercher un agent par
                <span class="font-weight-medium">nom, prénom ou email</span>.
              </p>
            </v-col>

            <v-col cols="3" class="d-flex flex-column align-center">
              <div class="d-flex align-center mb-1" >
                <v-icon color="grey lighten-1" size="28">mdi-plus</v-icon>
                <p class="font-weight-bold grey--text text--darken-1">Création rapide</p>
              </div>
              <p class="caption">
                Utilisez la
                <span class="key-chip">+ création rapide</span>
                pour créer un contact dont l'agence sera définie plus tard, au moment de la clôture du workshop.
              </p>
            </v-col>
          </v-row>
          <v-row class="pl-4 mt-4">
            <v-col cols="1" />
            <v-col cols="4" class="d-flex flex-column align-center">
              <div class="d-flex align-center mb-1" >
                <v-icon color="grey lighten-1" class="mr-1" size="28">mdi-help-circle-outline</v-icon>
                <p class="font-weight-bold grey--text text--darken-1">Je n'ai trouvé que l'agence</p>
              </div>
              <p class="caption">
                Une fois l'agence trouvée, vous accédez au menu de séléction des agents.
                Si la personne que vous recherchez ne s'y trouve pas, utilisez la
                <span class="key-chip">+ création d'agent rapide</span>
                afin de créer un agent qui lui sera associé.
                Renseignez un nom, un prénom ou un email puis complétez les informations plus tard.
              </p>
            </v-col>
            <v-col cols="2" />
            <v-col cols="4" class="d-flex flex-column align-center">
              <div class="d-flex align-center mb-1" >
                <v-icon color="grey lighten-1" class="mr-1" size="28">mdi-human-male-board-poll</v-icon>
                <p class="font-weight-bold grey--text text--darken-1">Le processus de clôture du workshop</p>
              </div>
              <p class="caption">
                Une fois l'évènement terminé, vous pouvez alors
                <span class="font-weight-medium">clôturer le workshop</span>.
                Vous serez alors invité à compléter les éventuelles informations manquantes.
                Cette action créera automatiquement les nouveaux agents ainsi que les événements,
                que vous retrouverez dans l'onglet <span class="key-chip">visites</span>.
                C'est pourquoi
                <span class="font-weight-medium">cette action est définitive</span>.
              </p>
            </v-col>

            <v-col cols="12">
              <v-divider />
            </v-col>

          </v-row>

          <v-row dense class="mb-4 px-4">
            <v-col cols="12" class="d-flex align-center">
              <v-icon color="grey lighten-1" size="40">mdi-progress-wrench</v-icon>
              <v-subheader class="grey--text text--darken-1 font-weight-bold pl-1">Raccourcis</v-subheader>
            </v-col>

            <v-col cols="6" class="d-flex flex-column align-start gap1">
              <p class="grey--text text--lighten-1 font-weight-medium">Lors de la saisie de la recherche</p>
              <div class="d-flex align-center gap1">
                <div class="key-chip d-flex justify-center align-center">
                  <v-icon size="16">mdi-magnify</v-icon>
                  <p class="plus">+</p>
                  <p>@</p>
                </div>
                <p class="caption">Commencer une saisie par
                  <span class="key-chip">@</span>
                  active la
                  <span class="font-weight-medium">recherche par agents</span>
                </p>
              </div>
              <div class="d-flex align-center gap1">
                <div class="key-chip d-flex justify-center align-center">
                  <v-icon size="16">mdi-magnify</v-icon>
                  <p class="plus">+</p>
                  <p>#</p>
                </div>
                <p class="caption">Commencer une saisie par
                  <span class="key-chip">#</span>
                  active la
                  <span class="font-weight-medium">recherche par agences</span>
                </p>
              </div>
            </v-col>

            <v-col cols="6" class="d-flex flex-column align-start gap1">
                <p class="grey--text text--lighten-1 font-weight-medium">Lors d'une création rapide ou dans le menu de sélection d'une agence</p>
              <div class="d-flex align-center gap1">
                <div class="key-chip d-flex justify-center align-center">
                  <v-icon size="16">mdi-plus</v-icon>
                  <p class="plus">|</p>
                  <p>n</p>
                </div>
                <p class="caption"> active la <span class="font-weight-medium">création rapide</span></p>
              </div>
              <div class="d-flex align-center gap1">
                <div class="key-chip">
                  <p>esc</p>
                </div>
                <p class="caption">Quitter, annuler</p>
              </div>
              <div class="d-flex align-center gap1">
                <div class="key-chip">
                  <v-icon size="16">mdi-keyboard-return</v-icon>
                </div>
                <p class="caption">Valider la création rapide ou la sélection dans l'agence</p>
              </div>
            </v-col>
          </v-row>

        </v-card>
      </v-col>
    </v-row>

    <!--close button-->
    <div v-if="canClose" class="close-btn cursor-pointer" @click="$emit('close-infos')">
      <v-chip small class="cursor-pointer">
        <v-icon small color="grey darken-1">mdi-close</v-icon>
      </v-chip>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "WorkshopInfoPanel",
  props: {
    showInfos: { type: Boolean, default: false },
    canClose: { type: Boolean, default: false },
  },
  emits: ['close-infos'],
}
</script>


<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.info-panel {
  position: relative;
}
.close-btn {
  position: absolute;
  top: 18px;
  right: 16px;
}

.gap1 {
  gap:4px;
}

.key-chip {
  padding: 2px 8px;
  background-color: #EEEEEE;  /* grey-lighten-3 */
  color: #757575;             /* grey-darken-1 */
  border-radius: 16px;
  font-weight: bold;
  gap:8px;
}
.key-chip .plus {
  color: #BDBDBD;            /* grey-lighten-1 */
  font-weight: normal;
  margin-right: 1px;
}
</style>